import { resolveOrganizationVerbiage } from "../../../config/organizationVerbiageConfig";
import { UserRole } from "../enums/profileEnums";

/**
 * English defaults for `user-role-*` i18n keys. API / GraphQL still use {@link UserRole} enum strings.
 */
export const USER_ROLE_LABEL_FALLBACKS: Record<UserRole, string> = {
  [UserRole.COMPANY_ADMIN]: "Company admin",
  [UserRole.STORE_ADMIN]: "Store admin",
  [UserRole.INVENTORY_CLERK]: "Inventory clerk",
  [UserRole.WAREHOUSE_MANAGER]: "Warehouse manager",
  [UserRole.SALES_PROCUREMENT]: "Sales & procurement",
  [UserRole.BUYER]: "Buyer",
  [UserRole.ANALYST]: "Analyst"
};

function userRoleTranslationKey(role: string): string {
  return `user-role-${role.toLowerCase().replace(/_/g, "-")}`;
}

function fallbackLabelForUnknownRole(role: string): string {
  return role
    .split("_")
    .filter(Boolean)
    .map((w) => w.charAt(0) + w.slice(1).toLowerCase())
    .join(" ");
}

/**
 * Localized label for a user/employee role. Raw enum values (e.g. `COMPANY_ADMIN`) are preserved in data; only display changes.
 */
export function formatUserRoleLabel(
  role: UserRole | string | undefined | null,
  t: (key: string, defaultValue: string) => string,
  businessType?: string | null
): string {
  const raw = role == null || role === "" ? "" : String(role).trim();
  if (!raw) return "";

  if (raw === UserRole.COMPANY_ADMIN && businessType) {
    const { adminRole } = resolveOrganizationVerbiage(businessType).labels;
    return t(adminRole.key, adminRole.fallback);
  }

  const defaultText =
    USER_ROLE_LABEL_FALLBACKS[raw as UserRole] ??
    fallbackLabelForUnknownRole(raw);
  return t(userRoleTranslationKey(raw), defaultText);
}
